import React from 'react';
import { Box, Typography } from '@mui/material';
import { errors } from './errorHelper';
import { useQuery } from '../../../hooks/urlHooks';

// eg: /#/error?errorTitle=Reset Password Link Expired&errorDescription=Your password reset link has expired.

const Error = () => {
  const { errorCode, errorTitle, errorDescription } = useQuery();
  const {
    errorCode: defaultErrorCode,
    errorTitle: defaultErrorTitle,
    errorDescription: defaultErrorDescription,
  } =
    Object.values(errors).find(
      ({ errorCode: code }) => Number(errorCode) === code
    ) || errors.default;
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h2">Error</Typography>
      <Typography variant="body1">{errorCode || defaultErrorCode}</Typography>
      <Typography variant="body1">{errorTitle || defaultErrorTitle}</Typography>
      <Typography variant="body2">
        {errorDescription || defaultErrorDescription}
      </Typography>
    </Box>
  );
};

export default Error;
